import { render, staticRenderFns } from "./FileOpenDialog.vue?vue&type=template&id=83c050ca&scoped=true"
import script from "./FileOpenDialog.vue?vue&type=script&lang=js"
export * from "./FileOpenDialog.vue?vue&type=script&lang=js"
import style0 from "./FileOpenDialog.vue?vue&type=style&index=0&id=83c050ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c050ca",
  null
  
)

export default component.exports